// extracted by mini-css-extract-plugin
export var fadeInOut = "_1t-3";
export var icon = "_1t-4";
export var savedIndicator = "_1t-2";
export var savingIndicator = "_1t-0";
export var spin = "_1t-1";